import { gql } from "@apollo/client";

export const REVIEW_BASE_GAME_FIELDS = gql`
  fragment ReviewEscapeGameFields on GameType {
    id
  }
`;

export const REVIEW_GAME_FIELDS = gql`
  fragment ReviewEscapeGameFields on GameType {
    id
    location {
      id
      company {
        id
        name
      }
      displayName
    }
    gameimageSet {
      id
      imageId
    }
    name
    primaryCategory {
      id
      name
      slug
      parent {
        id
        name
        slug
      }
    }
    slug
  }
`;

export const REVIEW_FIELDS = gql`
  fragment ReviewUserFields on UserType {
    id
    experiencesCountFacets {
      category {
        slug
      }
      count
    }
    imageId
    username
  }

  fragment ReviewFields on ExperienceReviewType {
    id
    components {
      id
      options {
        id
        value
      }
      question
      response {
        comment
        optionId
      }
      shortQuestion
      type
    }
    createdAt
    escape {
      id
      game {
        ...ReviewEscapeGameFields
      }
      gameDate
    }
    images {
      id
      imageId
    }
    isContainingSpoilers
    operatorResponse {
      body
      createdAt
      user {
        ...ReviewUserFields
      }
    }
    overallRating
    summary
    user {
      escapedCount
      ...ReviewUserFields
    }
  }
`;

export const QUERY = gql`
  {
    review(id: $reviewId) {
      ...ReviewFields
    }
  }
`;
